export enum MenuLinkType {
    SingleOrganiser = 'SINGLE_ORGANISER',
    PerCover = 'PER_COVER'
}
